export default __webpack_public_path__ + "static/conga_active-6a54901c81fcc6436df5e9bc8e2dcc90.png";